import { createFileRoute } from '@tanstack/react-router';

import { BannerPlacement } from '@/domain/enums';
import { BannersPage } from '@/features/banners/BannersPage';

interface BannersSearch {
  placement: BannerPlacement;
}

function BannersRoute() {
  const { placement } = Route.useSearch();
  return <BannersPage placement={placement} />;
}

export const Route = createFileRoute('/admin/_app/banners')({
  validateSearch: (search: Record<string, unknown>): BannersSearch => ({
    placement:
      search['placement'] === BannerPlacement.Login ? BannerPlacement.Login : BannerPlacement.Home,
  }),
  component: BannersRoute,
});
